import React, {useState} from "react";
import {useForm} from "react-hook-form";
import AttributeFields from "./AttributeFields";

export default function () {
  const {register, handleSubmit, reset, control, watch} = useForm({
    shouldUnregister: true
  });
  const [errors, setErrors] = useState({});
  const attributeFields = <AttributeFields {...{register, errors}} />;

  return {
    setErrors,
    attributeFields,
    handleSubmit,
    reset,
  }
}